import { MissionCodeType } from 'models/enums/fleet-management';
import CustomLocalizationType from 'models/enums/custom-localization-type';
import useCustomLocalizationEffect from './useCustomLocalizationEffect';

const LOCALIZATION_TYPES: Record<MissionCodeType, CustomLocalizationType> = {
  [MissionCodeType.ERROR]: CustomLocalizationType.ERROR_CODE,
  [MissionCodeType.MAINTENANCE]: CustomLocalizationType.MAINTENANCE_CODE,
};

/**
 * A mission code's CustomLocalization title and description. A code nobody has localized yet
 * keeps the raw code as its title and has no description.
 */
const useCodeLabel = () => {
  const localize = useCustomLocalizationEffect();
  return (code: string, type: MissionCodeType) => ({
    title: localize(code, LOCALIZATION_TYPES[type]) ?? code,
    description: localize(code, LOCALIZATION_TYPES[type], true),
  });
};

export default useCodeLabel;
